var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container,style:(_vm.styleObj)},[_c('div',{class:_vm.$style.badge}),_vm._v("\n  "+_vm._s(("" + (_vm.status.charAt(0).toUpperCase()) + (_vm.status.slice(1))))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }